import { hotList } from "@/mocks/guaContent";

export default function Trending() {
  return (
    <section id="hot" className="relative bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-sm font-semibold text-primary-600 tracking-wide">HOT · 今日热瓜</p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-900">
              此刻全网都在看什么
            </h2>
          </div>
          <p className="text-sm text-foreground-600">热榜实时更新，仅供信息聚合参考，事件后续以官方信源为准。</p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <ol className="lg:col-span-2 flex flex-col divide-y divide-background-200 border border-background-200 rounded-lg bg-background-100/60 overflow-hidden">
            {hotList.map((item, i) => (
              <li
                key={item.title}
                className="group flex items-center gap-4 md:gap-6 bg-background-50/70 px-4 md:px-6 py-4 hover:bg-background-100 transition cursor-pointer"
              >
                <span className="font-heading text-3xl md:text-4xl font-black text-primary-200 group-hover:text-primary-500 transition w-12 shrink-0 text-center">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-xs">
                    <span className="rounded-full bg-accent-100 text-accent-800 px-2 py-0.5 whitespace-nowrap">
                      {item.channel}
                    </span>
                    <span className="text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <h3 className="mt-1.5 font-medium text-foreground-900 group-hover:text-primary-700 transition text-sm md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-0.5 hidden sm:block text-xs text-foreground-500 line-clamp-1">{item.brief}</p>
                </div>
                <span className="flex items-center gap-1 text-xs text-primary-600 whitespace-nowrap shrink-0">
                  <i className="ri-fire-fill"></i> {item.heat}
                </span>
              </li>
            ))}
          </ol>

          <aside className="rounded-lg bg-primary-500 text-white p-7 flex flex-col justify-between overflow-hidden relative">
            <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full bg-white/10"></div>
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs">
                <i className="ri-mail-send-line"></i> 瓜报速递
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold leading-snug">
                热榜变化太快？交给瓜田日报
              </h3>
              <p className="mt-3 text-sm text-white/85 leading-relaxed">
                与其在评论区里补课，不如每天早上一封日报，把前一天的来龙去脉一次讲清，信息不掺水。
              </p>
            </div>
            <a
              href="#plans"
              className="mt-6 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-white text-primary-700 text-sm font-semibold px-5 py-3 hover:bg-primary-50 transition"
            >
              订阅日报 <i className="ri-arrow-right-line"></i>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}